import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';
import { useCasinoRoyale } from '@/hooks/query/use-casino-royale';
import { useSiteStore } from '@/store/site';

export const usePredictionMarket = () => {
	const { nonSport } = useLicSettings();
	const { openCasinoRoyale } = useCasinoRoyale();
	const deepLinkSiteInfo = useSiteStore(state => state.deepLinkSiteInfo);

	const canSeePredictionMarket = nonSport?.canSeePredictionMarket;
	const enablePredictionMarketBanner = canSeePredictionMarket && nonSport?.enablePredictionMarketBanner;
	const enablePredictionMarketPopup = canSeePredictionMarket && nonSport?.enablePredictionMarketPopup;
	const predictionMarketNewTagUntil = nonSport?.predictionMarketNewTagUntil
		? new Date(nonSport.predictionMarketNewTagUntil + 'T23:59:59.999Z').getTime()
		: new Date(new Date().setDate(new Date().getDate() + 1)).getTime();

	const openPredictionMarket = () => {
		openCasinoRoyale({
			sportTypeId: '105',
			betTypeId: '17610',
			isApp: deepLinkSiteInfo.isApp
		});
	};

	return {
		openPredictionMarket,
		canSeePredictionMarket,
		enablePredictionMarketBanner,
		enablePredictionMarketPopup,
		predictionMarketNewTagUntil
	};
};
